import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { NoticeStore } from 'feature/notice/NoticeStore'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import css from './Notice.module.scss'

type Props = {
  notice: NoticeStore
}

export const Notice = observer(({ notice }: Props) => {
  const { type, content, state } = notice
  const state_ = state === 'start' ? css.start : state === 'end' ? css.end : ''
  const type_ = type === 'info' ? css.info : type === 'success' ? css.success : type === 'error' ? css.error : ''

  const onClick = useLatestCallback(() => {
    notice.close()
  })

  return <Space className={clsx(css.notice, state_)} onClick={onClick}>
    <Space className={clsx(css.content, type_)}>
      {content}
    </Space>
  </Space>
})
